const WISHLIST_STORAGE_KEY = 'country_wishlist';
const VISITED_STORAGE_KEY = 'country_visited';
const USER_STORAGE_KEY = 'current_user';
const PASSPORT_STORAGE_KEY = 'user_passport';

export const saveToStorage = (key, data) => {
    try {
        localStorage.setItem(key, JSON.stringify(data))
    } catch (err) {
        console.error('Error saving to localStorage:', err)
    }
};

export const loadFromStorage = (key) => {
    try {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : null
    } catch (err) {
        console.error('Error loading from localStorage:', err)
        return null
    }
};

export const removeFromStorage = (key) => {
    try {
        localStorage.removeItem(key)
    } catch (err) {
        console.error('Error removing from localStorage:', err)
    } 
};

export const saveWishlistToStorage = (wishlist) => {
    let dataToSave = wishlist;
    if (
        Array.isArray(wishlist) &&
        wishlist.length > 0 &&
        wishlist[0]?.countryId !== undefined
    ) {
        const wishlistIds = wishlist.map(item => item.countryId);
        const priorities = {};
        wishlist.forEach(item => {
            if (item.priority) {
                priorities[item.countryId] = item.priority;
            }
        });
        dataToSave = {
            wishlist: wishlistIds,
            priorities
        };
    }
    else if (Array.isArray(wishlist)) {
        dataToSave = {
            wishlist,
            priorities: {}
        };
    }
    saveToStorage(WISHLIST_STORAGE_KEY, {
        data: dataToSave,
        timestamp: Date.now()
    });
};

export const loadWishlistFromStorage = () => {
    const storedData = loadFromStorage(WISHLIST_STORAGE_KEY);
    if (!storedData) return null;
    const rawData = storedData.data;
    if (
        rawData &&
        typeof rawData === 'object' &&
        rawData.wishlist !== undefined
    ) {
        return rawData;
    }
    if (Array.isArray(rawData)) {
        return {
            wishlist: rawData,
            priorities: {}
        };
    }
    return null;
};


export const saveVisitedlistToStorage = (visitedlist) => {

    let dataToSave = visitedlist;

    if (
        Array.isArray(visitedlist) &&
        visitedlist.length > 0 &&
        visitedlist[0]?.countryId !== undefined
    ) {
        const visitedIds = visitedlist.map(item => item.countryId);
        const visitMeta = {};
        visitedlist.forEach(item => {
            visitMeta[item.countryId] = {
                status: item.status || null,
                visitedMonth: item.visitedMonth || null,
                visitedYear: item.visitedYear || null,
                note: item.note || ''
            };
        });
        dataToSave = {
            visited: visitedIds,
            visitMeta
        };
    }

    else if (Array.isArray(visitedlist)) {
        dataToSave = {
            visited: visitedlist,
            visitMeta: {}
        };
    }
    saveToStorage(VISITED_STORAGE_KEY, {
        data: dataToSave,
        timestamp: Date.now()
    });
};

export const loadVisitedlistFromStorage = () => {
    const storedData = loadFromStorage(VISITED_STORAGE_KEY);
    if (!storedData) return null;
    const rawData = storedData.data;
    if (
        rawData &&
        typeof rawData === 'object' &&
        rawData.visited !== undefined
    ) {
        return rawData;
    }
    if (Array.isArray(rawData)) {
        return {
            visited: rawData,
            visitMeta: {}
        };
    }
    return null;
};

export const savePassportToStorage = (passport) => {
    saveToStorage(PASSPORT_STORAGE_KEY, passport);
};

export const loadPassportFromStorage = () => {
    return loadFromStorage(PASSPORT_STORAGE_KEY);
};

export const saveUserToStorage = (userId) => {
    saveToStorage(USER_STORAGE_KEY, userId)
};

export const loadUserFromStorage = () => {
    return loadFromStorage(USER_STORAGE_KEY)
};

export const clearUserStorage = () => {
    removeFromStorage(WISHLIST_STORAGE_KEY);
    removeFromStorage(VISITED_STORAGE_KEY);
    removeFromStorage(USER_STORAGE_KEY);
    removeFromStorage(PASSPORT_STORAGE_KEY)
};